import * as Yup from "yup";
import { enqueueSnackbar } from "notistack";
import { errorsMessage } from "../../helpers";
import { api } from "../../services/api";

export function useZoneForm({ zone, getZones, handleClose }) {
  const initialValues = {
    id: zone?.Id || "",
    Nome: zone?.Nome || "",
    Classificacao: zone?.Classificacao || ""
  };

  const validationSchema = Yup.object().shape({
    Nome: Yup.string().required("Informe o nome"),
    Classificacao: Yup.string().required("Informe a classificação")
  });

  const onSubmit = async (values, { setSubmitting, setStatus, resetForm }) => {
    try {
      setSubmitting(true);

      const { id, ...formData } = values;

      const path = id ? `/zonas/${id}` : `/zonas`;
      const method = id ? "put" : "post";

      await api[method](path, formData);

      resetForm();
      enqueueSnackbar("Dados salvos com sucesso!", {
        variant: "success"
      });
      getZones();
      handleClose();
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
      setStatus({ success: false });
      setSubmitting(false);
    }
  };

  return {
    onSubmit,
    initialValues,
    validationSchema
  };
}
